import { ModelLookupContext, ModelLookupProduct, ViewNames } from "@auer-steel/Contexts/ModelLookup/ModelLookupContext";
import ModelLookup from "@auer-steel/CustomTypes/ModelLookup";
import ModelPartsLookup from "@auer-steel/CustomTypes/ModelPartsLookup";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import React, { useState } from "react";

const ModelLookupContextProvider = (props: { children: React.ReactNode }) => {
    const [viewNames, setViewNames] = useState<ViewNames>({
        modelSearchResultsList: "modelSearchResultsList",
        modelSearchListDetail: "modelSearchListDetail",
    });
    const [modelNumber, setModelNumber] = useState("");
    const [displayDetailsView, setDisplayDetailsView] = useState(false);
    const [modelLookupResultsData, setModelLookupResultsData] = useState({} as ModelLookup);
    const [modelPartsLookupResultsData, setModelPartsLookupResultsData] = useState([] as ModelPartsLookup[]);
    const [currentSelectedGroup, setCurrentSelectedGroup] = useState("");
    const [currentSelectedProduct, setCurrentSelectedProduct] = useState({} as ProductDto);
    const [currentModelLookupProduct, setCurrentlySelectedPartKey] = useState<ModelLookupProduct[]>([
        {
            criticalPart: "",
            drawingExists: "",
            drawingLink: "",
            groups: "",
            modelFamily: "",
            partDescription: "",
            partHistory: "",
            partNumber: "",
            partQuantity: 0,
            replacedPartNumber: "",
            salesPackageNumber: "",
            sequenceNumber: "",
            sigChartLink: "",
            showSpinner: false,
        },
    ]);
    const [modelLookupRootUri, setModelLookupRootUri] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSetModelNumber = (data: string) => {
        setModelNumber(data);
    };

    const handleSetDisplayDetailsView = (data: boolean) => {
        setDisplayDetailsView(data);
    };

    const handleSetModelLookupResultsData = (data: ModelLookup) => {
        setModelLookupResultsData(data);
    };

    const handleSetModelPartsLookupResultsData = (data: ModelPartsLookup[]) => {
        setModelPartsLookupResultsData(data);
    };

    const handleSetCurrentSelectedProduct = (data: ProductDto) => {
        setCurrentSelectedProduct(data);
    };

    const handleSetCurrentSelectedGroup = (group: string) => {
        setCurrentSelectedGroup(group);
    };

    const handleSetIsLoading = (isLoading: boolean) => {
        setIsLoading(isLoading);
    };

    const handleSetCurrentModelLookupProduct = (data: ModelLookupProduct[]) => {
        setCurrentlySelectedPartKey(data);
    };

    const handleSetModelLookupRootUri = (data: string) => {
        setModelLookupRootUri(data);
    };

    return (
        <ModelLookupContext.Provider
            value={{
                currentModelLookupProduct,
                currentSelectedGroup,
                currentSelectedProduct,
                displayDetailsView,
                isLoading,
                modelLookupResultsData,
                modelLookupRootUri,
                modelNumber,
                modelPartsLookupResultsData,
                handleSetCurrentModelLookupProduct,
                handleSetCurrentSelectedGroup,
                handleSetCurrentSelectedProduct,
                handleSetDisplayDetailsView,
                handleSetIsLoading,
                handleSetModelLookupResultsData,
                handleSetModelLookupRootUri,
                handleSetModelNumber,
                handleSetModelPartsLookupResultsData,
            }}
        >
            {props.children}
        </ModelLookupContext.Provider>
    );
};

export { ModelLookupContextProvider };
